<template>
  <div class="full-height">
    <div class="height-26 d-flex justify-end full-width" style="margin-top:20px;">
      <v-row class="d-flex align-center full-height" no-gutters>
        <v-row v-if="isHorse" no-gutters>
          <v-col cols="2" />
          <v-col cols="6" />
          <v-col cols="4" class="text-center">
            <v-row no-gutters>
              <v-col v-for="(item, index) in horseEffort" :key="`horseEffort_${index}`" cols="4">
                <v-icon button :style="computeEffortStyle(item.value)" @click="orderHorseEffort(item.key)"> {{ item.value === horsesEffortSorting.DESC ? 'mdi-arrow-down-thick' : 'mdi-arrow-up-thick' }}</v-icon>
                <div class="header-letter mt-2" :class="item.background">
                  <span>{{ item.name }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-row>
    </div>
    <ul v-for="contentType in computedContentTypes" :key="contentType.uuid" :style="`height: ${contentType.sessions.size * 35}px`">
      <div>
        <li v-for="(row, index) in contentType.sessions.size" :key="`contentTimeTable_${index}`" class="height-35">
          <v-row class="d-flex align-center full-height" no-gutters>
            <ListValue v-if="index === 0" :content-type="contentType" />
          </v-row>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';
import ListValue from './ListValue.vue';
import { rowPerContentType, minutesToHours } from '../../../helpers/utils';
import { horsesEffortSorting } from '@/configs/references';

export default {
  components: { ListValue },
  props: {
    contentTypes: {
      type: Array,
      default () {
        return [];
      }
    },
    horseEffortStats: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  setup (props, context) {
    const isHorse = computed(() => props.contentTypes && props.contentTypes.length && props.contentTypes.every(ct => ct.wtype === 'horse'));

    const horseEffort = computed(() => props.horseEffortStats);

    const orderHorseEffort = orderBy => {
      context.emit('orderHorseEffort', orderBy);
    };

    const computeEffortStyle = state => (state === 0 ? 'opacity: 0.2' : 'opacity: 1');

    /**
     * @return {Object} return and array of contentTypes
     * ex: [{  }, {  }]
     * each content type contains an array of sessions that is an MAP containing row and each session per row
     */

    const computedContentTypes = computed(() => rowPerContentType(props.contentTypes));

    return { isHorse, computedContentTypes, minutesToHours, horseEffort, orderHorseEffort, horsesEffortSorting, computeEffortStyle };
  }
};
</script>

<style lang="scss" scoped>
  .header-letter {
    height: 22px;
  }
</style>
